// @flow

import React from 'react';
import ReactDOM from 'react-dom';

import _ from 'lodash';

// -- constants
import Config from 'constants/Config';
import Events from 'constants/Events';

// -- utils
import Logger from 'PMT/utils/Logger';

// -- entities
import { ProAccount } from 'PMT/entities/security';

// -- stores
import { ProAccountStore, SessionStore } from 'stores';

// -- router
import {Router} from 'react-router-dom';

import ApiManager from 'PMT/api/ApiManager';
import apiManagerOptions from './constants/ApiManagerOptions';

import DevelopmentUtils from 'PMT/utils/DevelopmentUtils';

// polyfills for Intl
import '@formatjs/intl-locale/polyfill-force.js';
import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/locale-data/de';
import '@formatjs/intl-pluralrules/locale-data/fr';
import '@formatjs/intl-pluralrules/locale-data/en';

import 'font-awesome/css/font-awesome.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';

import { IntlProvider } from 'react-intl';
import I18n from 'PMT/i18n/I18n';

import locale_fr from '../public/locales/fr.json';
import locale_en from '../public/locales/en.json';
import locale_de from '../public/locales/de.json';

import '../styles/main.scss';
import AppRoutes from "./routes"
import appHistory from "./history"

const localeData = {
  fr: locale_fr,
  en: locale_en,
  de: locale_de,
};

/**
 * ---- Logger configuration
 */

Logger.configure({
  SENTRY_URL: Config.Logger.SENTRY_URL,
  DISPLAY_REPORT_DIALOG: Config.Logger.DISPLAY_REPORT_DIALOG,
  APP_VERSION: Config.VERSION
});

// set default user context when we load the page
const proAccount: ProAccount = ProAccountStore.getMeAccount();
if (!_.isNil(proAccount)) {
  Logger.setUserContext(Logger.UserRole.RESTAURANT, proAccount.id);
} else {
  Logger.setUserContext(Logger.UserRole.ANONYMOUS, '');
}

/**
 * ---- Why did you update configuration
 */

// import whyDidYouUpdate from 'why-did-you-update';

/**
 * Enable https://github.com/garbles/why-did-you-update tool on development mode.
 */
if (process.env.NODE_ENV !== 'production' && (Config.IS_DEV || Config.IS_PREPROD)) {
  //  whyDidYouUpdate(React,  { include: /^pure/, exclude: /^Connect/ });
}

//
// ApiManager configuration
//

ApiManager.configure(apiManagerOptions);

//
// I18n
//

I18n.configure(localeData);
I18n.changeLocale(SessionStore.getLocale());

//
// Dev configuration
//
if (Config.IS_DEV) {
  DevelopmentUtils.setDevMode();
  DevelopmentUtils.initializeAtomReactInspector();
  DevelopmentUtils.initializeDevTools({}, Events);
}

/**
 * ---- Route documentation
 */
const element = document.getElementById('app');

const routerView = (
    <IntlProvider locale={I18n.locale} messages={I18n.messages}>
      <Router history={appHistory}>
        <AppRoutes/>
      </Router>
    </IntlProvider>
);

ReactDOM.render(
  routerView,
  element
);

//RouteStore.getRouter().run((Handler: Object, state: Object) => {
//  ReactDOM.render(<Handler state={state} />, document.getElementById('app'));
//});
if (module.hot) {
  module.hot.accept()
}
